import React from "react";
import "./statWidget.css";

export const StatWidget = ({ icon: Icon, title, value, subLabel }) => {
  return (
    <div className="stat-card">
      <div className="stat-card-header">
        <div className="stat-card-icon">
          <Icon sx={{ width: '48px', height: '48px', color: '#272727' }} />
        </div>
        <span className="stat-card-title">{title}</span>
      </div>

      <div className="stat-card-value">{value}</div>

      <div className="stat-card-sublabel">{subLabel}</div>
    </div>
  );
}
